import ReactMarkdown from "react-markdown";
import { useNavigate } from "react-router-dom";

// Answers arrive as markdown (the prompt asks for lists where they help), so they must be
// rendered — plain text showed literal "**$48,250**" in every reply.
export const AnswerBody = ({ text, testid = "copilot-answer-body" }) => {
  const navigate = useNavigate();
  return (
    <div className="copilot-answer" data-testid={testid}>
      <ReactMarkdown
        components={{
          p: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
          ul: ({ children }) => <ul className="list-disc pl-5 mb-2 last:mb-0 space-y-1">{children}</ul>,
          ol: ({ children }) => <ol className="list-decimal pl-5 mb-2 last:mb-0 space-y-1">{children}</ol>,
          strong: ({ children }) => <strong className="font-semibold text-ink">{children}</strong>,
          h1: ({ children }) => <div className="font-heading font-bold mb-1.5">{children}</div>,
          h2: ({ children }) => <div className="font-heading font-bold mb-1.5">{children}</div>,
          h3: ({ children }) => <div className="font-heading font-bold mb-1.5">{children}</div>,
          code: ({ children }) => <code className="rounded bg-sand-100 px-1 py-0.5 text-[12px]">{children}</code>,
          pre: ({ children }) => <pre className="rounded-xl bg-sand-50 border border-sand-200 p-2.5 mb-2 overflow-x-auto text-[12px]">{children}</pre>,
          a: ({ children, href }) => (href || "").startsWith("/") ? (
            <a href={href} data-testid="copilot-internal-link" onClick={(e) => { e.preventDefault(); navigate(href); }}
              className="font-semibold text-redline-600 underline decoration-redline-300 hover:decoration-redline-600">{children}</a>
          ) : (
            <a href={href} target="_blank" rel="noreferrer" className="text-redline-600 underline">{children}</a>
          ),
          table: ({ children }) => (
            <div className="overflow-x-auto mb-2"><table className="text-xs border-collapse">{children}</table></div>
          ),
          th: ({ children }) => <th className="border border-sand-200 px-2 py-1 bg-sand-50 text-left">{children}</th>,
          td: ({ children }) => <td className="border border-sand-200 px-2 py-1 align-top">{children}</td>,
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
};
